import React from "react";
import _ from "lodash";
import { Button } from "@mui/material";
import IconNewRecord from "src/assets/images/icon_newrecord.svg";
import { getFloatValue } from "src/constant";

export const DepotTableDataPage = ({
  depoData,
  handleRowClick,
  selectedRow,
  showViewRecordButton,
  handleViewRecordButtonClick,
  handleOpen,
}) => {
  
  return (
    <>
      <div
        className={`table-responsive ${
          depoData?.length < 10 ? "" : "main-div-depots-tab"
        } d-flex`}
      >
        <table className="table admintab-depots-table table-borderless">
          <thead>
            <tr>
              <th scope="col" style={{ minWidth: "200px" }}>
                DEPOT
              </th>
              <th scope="col" style={{ minWidth: "400px" }}>
                ADDRESS
              </th>
              <th scope="col" style={{ minWidth: "100px" }}>
                INTERNAL (m<sup>2</sup>)
              </th>
              <th scope="col" style={{ minWidth: "102px" }}>
                EXTERNAL (m<sup>2</sup>)
              </th>
              <th scope="col" style={{ minWidth: "100px" }}>
                TOTAL (m<sup>2</sup>)
              </th>
              <th scope="col" style={{ minWidth: "80px" }}>
                MANAGERS
              </th>
            </tr>
          </thead>
          <tbody className="depots-admin-tbl-body mt-2">
            {depoData.length > 0 &&
              _.orderBy(depoData, (d) => d.name.toLowerCase(), ["asc"]).map(
                (item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr
                        onClick={() => handleRowClick(item)}
                        className={`depottab-table-body-tr ${
                          selectedRow.id == item.id ? "row-border" : ""
                        }`}
                      >
                        <td>
                          {item?.name} {`[${item?.code}]`}
                        </td>
                        <td>
                          {item?.address?.plotNumber}&nbsp;
                          {item?.address?.street1}&nbsp;,
                          {item?.address?.street2}&nbsp;
                          {item?.address?.city}&nbsp;,
                          {item?.address?.state}&nbsp;
                          {item?.address?.country}&nbsp;,
                          {item?.address?.zip}
                        </td>
                        <td>{item?.internalArea}</td>
                        <td>{item?.externalArea}</td>
                        <td>
                          {getFloatValue(
                            (item?.internalArea || 0) +
                              (item?.externalArea || 0)
                          )}
                        </td>
                        <td>
                          {item.depotUsers.length > 0
                            ? item.depotUsers.length
                            : 0}
                        </td>
                      </tr>
                      {showViewRecordButton && selectedRow.id == item.id && (
                        <tr className={`view-record-button`}>
                          <td>
                            <button
                              type="button"
                              className="text-uppercase view-button"
                              onClick={handleViewRecordButtonClick}
                            >
                              <i className="bi bi-eye-fill view-record-icon"></i>{" "}
                              View Record
                            </button>
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                }
              )}
          </tbody>
        </table>
      </div>
      <div
        style={{ height: 60, marginRight: 20 }}
        className="d-flex flex-row justify-content-end align-items-center"
      >
        <Button
          variant="outlined"
          className="btn-bootstrap-submit-style"
          startIcon={
            <img src={IconNewRecord} width={17} height={17} alt="new"></img>
          }
          type="submit"
          onClick={handleOpen}
        >
          Add Depot
        </Button>
      </div>
    </>
  );
};
